import { merge } from 'lodash'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  menuOpen: boolean
  modalOpen: boolean
  headerHide: boolean
  headerBackground: boolean
  srollDownHidden: boolean
  footerTheme?: 'dark' | 'light'
  lockScroll: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setState: (state?: Partial<State>) => void
}

const initialState: State = {
  menuOpen: false,
  modalOpen: false,
  headerBackground: false,
  headerHide: false,
  lockScroll: false,
  srollDownHidden: false,
  footerTheme: undefined
}

const useLayoutStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      ...initialState,
      setState: (state) => set((prevState) => merge(prevState, state))
    }))
  )
)

export { useLayoutStore }
